import type { SpinnerProps } from "@/ui/core/Spinner";
import Spinner from "@/ui/core/Spinner";
import { Box, ScreenContainer } from "@/ui/layout";

const FullScreenSpinner = ({ color }: SpinnerProps) => {
  return (
    <ScreenContainer>
      <Box height="100%" justifyContent="center" width="100%">
        <Spinner color={color} size="large" />
      </Box>
    </ScreenContainer>
  );
};

export default FullScreenSpinner;
